function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SettlersState = /*#__PURE__*/function () {
  function SettlersState() {
    _classCallCheck(this, SettlersState);
  }
  return _createClass(SettlersState, [{
    key: "generateMap",
    value:
    /*
      Every player should have in deck[2] and deck[3] the board tiles and tokens in the same order
      */
    function generateMap() {
      var tileCt = 0;
      var tokenCt = 0;
      var tile, resourceName, token;
      var _iterator = _createForOfIteratorHelper(this.hexgrid.hexes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var hex = _step.value;
          tile = this.game.pool[0].hand[tileCt++];
          resourceName = this.game.deck[1].cards[tile].resource;
          if (resourceName != this.returnNullResource()) {
            var temp = this.game.pool[1].hand[tokenCt++];
            token = this.game.deck[2].cards[temp].value;
          } else {
            token = 0;
          }
          this.game.state.hexes[hex] = {
            resource: resourceName,
            value: token,
            img: this.game.deck[1].cards[tile].img,
            neighbours: [],
            robber: false
          };
          if (resourceName == this.returnNullResource()) this.game.state.hexes[hex].robber = true;
          if (token) this.addSectorValueToGameboard(hex, token);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /*
      Given a resource cost and player, check if they meet the minimum
      requirement = ["res1","res2"...]
    */
  }, {
    key: "doesPlayerHaveResources",
    value: function doesPlayerHaveResources(player, requirement) {
      var myBank = this.game.state.players[player - 1].resources.slice();
      var _iterator2 = _createForOfIteratorHelper(requirement),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var x = _step2.value;
          var ind = myBank.indexOf(x);
          if (ind >= 0) myBank.splice(ind, 1);else return false;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return true;
    }
  }, {
    key: "returnResources",
    value: function returnResources() {
      var newArray = [];
      var _iterator3 = _createForOfIteratorHelper(this.resources),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var i = _step3.value;
          //Filter desert
          if (!(i !== null && i !== void 0 && i["null"])) newArray.push(i.name);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return newArray;
    }

    //
    // this should be returnCardImage, and the other function should be renamed somehow -- return resource image?
    //
  }, {
    key: "returnResourceHTML",
    value: function returnResourceHTML(resource) {
      return "<div class=\"tip\"><img class=\"icon\" src=\"".concat(this.returnCardImage(resource), "\" /></div>");
    }
  }, {
    key: "returnCardImage",
    value: function returnCardImage(res) {
      var _iterator4 = _createForOfIteratorHelper(this.resources),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var i = _step4.value;
          if (i.name == res) {
            if (i.card) {
              return i.card;
            } else {
              return "".concat(this.cardDir).concat(res, ".png");
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return null;
    }
  }, {
    key: "returnHexes",
    value: function returnHexes() {
      var hexes = [];

      //Alter the island composition
      if (this.game.players.length == 2) {
        var _iterator5 = _createForOfIteratorHelper(this.resources),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var i = _step5.value;
            if (i.name == "wood" || i.name == "wheat" || i.name == "desert") {
              i.count = 3;
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
      var _iterator6 = _createForOfIteratorHelper(this.resources),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _i = _step6.value;
          for (var j = 0; j < _i.count; j++) {
            if (_i.tile) hexes.push({
              resource: _i.name,
              img: _i.tile
            });else hexes.push({
              resource: _i.name,
              img: this.randomizeTileImage(_i)
            });
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return hexes;
    }
  }, {
    key: "returnDevelopmentCards",
    value: function returnDevelopmentCards(option) {
      var deck = [];
      var _iterator7 = _createForOfIteratorHelper(this.deck),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var i = _step7.value;
          for (var j = 0; j < i.count; j++) {
            deck.push(i);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      return deck;
    }
  }, {
    key: "returnPortIcon",
    value: function returnPortIcon(res) {
      if (res == "any") {
        return "<img class=\"icon\" src=\"/settlers/img/icons/any-port.png\">";
      }
      var _iterator8 = _createForOfIteratorHelper(this.resources),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var i = _step8.value;
          if (i.name == res) {
            if (i.icon) {
              return "<img class=\"icon\" src=\"".concat(i.icon.replace('-icon', '-port'), "\">");
            }
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      return "2:1 ".concat(this.resourceIcon(res));
    }
  }, {
    key: "returnNullResource",
    value: function returnNullResource() {
      var _iterator9 = _createForOfIteratorHelper(this.resources),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var i = _step9.value;
          if (i["null"]) {
            return i.name;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
  }, {
    key: "isActionCard",
    value: function isActionCard(cardname) {
      var _iterator0 = _createForOfIteratorHelper(this.deck),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var c = _step0.value;
          if (cardname == c.card && c.action > 0) {
            return true;
          }
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
      return false;
    }
  }, {
    key: "randomizeTileImage",
    value: function randomizeTileImage(resObj) {
      var tileDir = "/settlers/img/sectors/";
      var x = Math.ceil(Math.random() * resObj.ict);
      return tileDir + resObj.name + x + ".png";
    }
  }, {
    key: "returnDiceTokens",
    value: function returnDiceTokens() {
      var dice = [];
      for (var i = 2; i <= 12; i++) {
        if (i !== 7) {
          dice.push({
            value: i
          });
        }
      }
      var start = this.game.players.length > 2 ? 3 : 4;
      var stop = this.game.players.length > 2 ? 11 : 10;
      for (var _i2 = start; _i2 <= stop; _i2++) {
        if (_i2 !== 7) {
          dice.push({
            value: _i2
          });
        }
      }
      return dice;
    }
  }, {
    key: "returnCitySlotsAdjacentToPlayerRoads",
    value: function returnCitySlotsAdjacentToPlayerRoads(player) {
      var adjacentVertices = [];

      //Cycle through roads to find all adjacent vertices
      for (var i = 0; i < this.game.state.roads.length; i++) {
        if (this.game.state.roads[i].player == player) {
          var slot = this.game.state.roads[i].slot.replace("road_", "");
          //console.log(this.game.state.roads[i],slot);
          var _iterator1 = _createForOfIteratorHelper(this.hexgrid.verticesFromEdge(slot)),
            _step1;
          try {
            for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
              var vertex = _step1.value;
              if (!adjacentVertices.includes(vertex)) adjacentVertices.push(vertex);
            }
          } catch (err) {
            _iterator1.e(err);
          } finally {
            _iterator1.f();
          }
        }
      }

      // Filter for available slots
      var existing_adjacent = [];
      for (var _i3 = 0, _adjacentVertices = adjacentVertices; _i3 < _adjacentVertices.length; _i3++) {
        var _vertex = _adjacentVertices[_i3];
        var city = document.querySelector("#city_" + _vertex);
        if (city && city.classList.contains("empty")) {
          existing_adjacent.push("city_" + _vertex);
        }
      }
      //console.log(existing_adjacent);
      var adjacent = existing_adjacent;
      return adjacent;
    }

    /*
    Used to prevent placing settlements too close together,
    for a given vertex coordinate, returns list of 2-3 adjacent vertices
    */
  }, {
    key: "returnAdjacentCitySlots",
    value: function returnAdjacentCitySlots(city_slot) {
      var adjacent = [];
      var vertexID = city_slot.replace("city_", "");
      var _iterator10 = _createForOfIteratorHelper(this.hexgrid.adjacentVertices(vertexID)),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var vertex = _step10.value;
          adjacent.push("city_" + vertex);
        }
        //console.log("Vertex: ",city_slot," Neighbors: ",adjacent);
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      return adjacent;
    }

    /*
      Set everything to zero by default
    */
  }, {
    key: "addSectorValuesToGameboard",
    value: function addSectorValuesToGameboard() {
      var _iterator11 = _createForOfIteratorHelper(this.hexgrid.hexes),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var i = _step11.value;
          this.addSectorValueToGameboard(i, 0);
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }
  }, {
    key: "addSectorValueToGameboard",
    value: function addSectorValueToGameboard(hex, sector_value) {
      var selector = "hex_bg_" + hex;
      var hexobj = document.getElementById(selector);
      var svid = "sector_value_".concat(hex);

      //Create Sector_value
      var sector_value_html = "\n            <div class=\"sector-container sc".concat(sector_value, "\" id=\"").concat(svid, "\">\n                <div class=\"sector_value hexTileCenter sv").concat(sector_value, "\" id=\"").concat(svid, "\">").concat(sector_value, "</div>\n            </div>\n        ");
      if (document.getElementById(svid)) {
        this.app.browser.replaceElementById(sector_value_html, svid);
      } else {
        var sector_value_obj = this.app.browser.htmlToElement(sector_value_html);
        if (hexobj) {
          hexobj.after(sector_value_obj);
        }
      }
      return svid;
    }

    /*
       Hardcode the position of resource ports
       Use road id + adjacent vertices for internal logic
     */
  }, {
    key: "addPortsToGameboard",
    value: function addPortsToGameboard() {
      if (Object.keys(this.game.state.ports).length == 9) {
        //Just read the port information and call the function
        for (var p in this.game.state.ports) {
          var hex = p.substr(2);
          var dir = p[0];
          this.addPortToGameboard(hex, this.game.state.ports[p], dir);
        }
      } else {
        //Define the ports -- randomly!!!!
        var resources = this.returnResources();
        resources.push("any", "any", "any", "any");
        console.log(resources);
        var hexes = ["1_1", "3_5", "5_4", "4_2", "1_2", "2_1", "5_3", "5_5", "2_4"];
        var angles = [6, 3, 3, 5, 1, 5, 4, 2, 1];
        for (var i = 0; i < 9; i++) {
          var r = resources.splice(this.rollDice(resources.length) - 1, 1);
          this.addPortToGameboard(hexes[i], r[0], angles[i]);
        }
      }
    }
  }, {
    key: "addPortToGameboard",
    value: function addPortToGameboard(hex, port, direction) {
      var port_id = "port_" + direction + "_" + hex;
      this.game.state.ports[direction + "_" + hex] = port;
      if (!this.browser_active) {
        return;
      }
      var selector = "hex_bg_" + hex;
      var hexobj = document.getElementById(selector);
      if (!document.getElementById(port_id)) {
        var port_html = "<div class=\"port port".concat(direction, "\" id=\"").concat(port_id, "\">\n                        <div class=\"ship hexTileCenter\">").concat(this.returnPortIcon(port), "</div>\n                        <div class=\"harbor lharbor\"></div>\n                        <div class=\"harbor rharbor\"></div>\n                        </div>");
        var port_obj = this.app.browser.htmlToElement(port_html);
        if (hexobj) hexobj.after(port_obj);
        //else console.log("Null selector: "+selector);
      }
    }

    /*
    Creates DOM stuctures to hold cities, 
    addCityToGameboard calculates where to (absolutely) position them
    */
  }, {
    key: "addCitiesToGameboard",
    value: function addCitiesToGameboard() {
      var _iterator12 = _createForOfIteratorHelper(this.hexgrid.hexes),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var i = _step12.value;
          this.addCityToGameboard(i, 6);
          this.addCityToGameboard(i, 1);
        }
        //Right side corners
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      this.addCityToGameboard("1_3", 2);
      this.addCityToGameboard("2_4", 2);
      this.addCityToGameboard("3_5", 2);
      this.addCityToGameboard("4_5", 2);
      this.addCityToGameboard("5_5", 2);
      this.addCityToGameboard("3_5", 3);
      this.addCityToGameboard("4_5", 3);
      this.addCityToGameboard("5_5", 3);

      //Left Under side
      this.addCityToGameboard("3_1", 5);
      this.addCityToGameboard("4_2", 5);
      this.addCityToGameboard("5_3", 5);
      //Bottom
      this.addCityToGameboard("5_3", 4);
      this.addCityToGameboard("5_4", 5);
      this.addCityToGameboard("5_4", 4);
      this.addCityToGameboard("5_5", 5);
      this.addCityToGameboard("5_5", 4);
    }

    /*
    Hexboard row_col indexed, city_component is point of hexagon (1 = top, 2 = upper right, ... )
    */
  }, {
    key: "addCityToGameboard",
    value: function addCityToGameboard(hex, city_component) {
      //let el = document.querySelector('.game-hexgrid-cities');
      //let hexobj = document.getElementById(hex);
      var city_id = "city_" + city_component + "_" + hex;

      // Calculate position value
      //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
      var neighbors = this.hexgrid.hexesFromVertex(city_component + "_" + hex);
      var score = 0;
      var _iterator13 = _createForOfIteratorHelper(neighbors),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var n = _step13.value;
          score += 6 - Math.abs(7 - this.game.state.hexes[n].value);
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      var selector = "hex_bg_" + hex;
      var hexobj = document.getElementById(selector);
      if (!document.getElementById(city_id)) {
        var city_html = "<div class=\"city city".concat(city_component, " empty\" id=\"").concat(city_id, "\" data-score=\"").concat(score, "\"></div>");
        var city_obj = this.app.browser.htmlToElement(city_html);
        if (hexobj) hexobj.after(city_obj);
        //else console.log("Null selector: "+selector);
      }
    }
  }, {
    key: "addRoadToGameboard",
    value: function addRoadToGameboard(hex, road_component) {
      var selector = "hex_bg_" + hex;
      var road_id = "road_" + road_component + "_" + hex;
      var hexobj = document.getElementById(selector);
      if (hexobj && !document.getElementById(road_id)) {
        console.log("Add road to gameboard: " + road_id);
        $(hexobj).after("<div class=\"road road".concat(road_component, " empty\" id=\"").concat(road_id, "\"></div>"));
      }
    }
  }, {
    key: "removeEvents",
    value: function removeEvents() {
      $(".trade").off();
    }
  }, {
    key: "randomMsg",
    value: function randomMsg() {
      var choices = ["nothing gained", "a poor harvest", "unlucky roll", "better luck next time"];
      var die = Math.floor(Math.random() * choices.length);
      return choices[die];
    }
  }]);
}();
module.exports = SettlersState;